import type { TOC } from '@ember/component/template-only';
import { hash } from '@ember/helper';
import type { WithBoundArgs } from '@glint/template';
import GeneralCurrencyPickerGroup from 'lumen/components/general/currency-picker/group';
import GeneralCurrencyPickerItem from 'lumen/components/general/currency-picker/item';
import GeneralDropdownsDropdownYield from 'lumen/components/general/dropdowns/dropdown-yield';
import GeneralDropdownsTriggersTriggerDropdownBasic from 'lumen/components/general/dropdowns/triggers/trigger-dropdown-basic';

interface GeneralCurrencyPickerMenuSignature {
  Args: {
    onClose?: () => void;
    triggerLabel: string;
  };
  Blocks: {
    default: [
      {
        group: WithBoundArgs<typeof GeneralCurrencyPickerGroup, never>;
        item: WithBoundArgs<typeof GeneralCurrencyPickerItem, 'dropdown'>;
      },
    ];
    footer: [
      {
        item: WithBoundArgs<typeof GeneralCurrencyPickerItem, 'dropdown'>;
      },
    ];
    header: [];
  };
  Element: HTMLDivElement;
}

const GeneralCurrencyPickerMenu: TOC<GeneralCurrencyPickerMenuSignature> =
  <template>
    <GeneralDropdownsDropdownYield
      @dropdownClass=".dropdown-target"
      {{! @glint-expect-error: Incorrect type }}
      @dropdownClassName="dropdown-target w-max right-0"
      @onCancel={{@onClose}}
      @selected={{@triggerLabel}}
      @triggerComponent={{GeneralDropdownsTriggersTriggerDropdownBasic}}
      as |dropdown|
    >
      <div class="flex flex-col leading-normal" ...attributes>
        {{#if (has-block "header")}}
          <div class="border-neutral-default border-b border-solid p-200">
            {{yield to="header"}}
          </div>
        {{/if}}

        <div class="flex-1 overflow-y-auto">
          {{yield
            (hash
              group=(component GeneralCurrencyPickerGroup)
              item=(component GeneralCurrencyPickerItem dropdown=dropdown)
            )
          }}
        </div>

        <div class="border-neutral-default border-t border-solid">
          {{yield
            (hash item=(component GeneralCurrencyPickerItem dropdown=dropdown))
            to="footer"
          }}
        </div>
      </div>
    </GeneralDropdownsDropdownYield>
  </template>;

export default GeneralCurrencyPickerMenu;
